import { getDefaultSiteByDomain } from '../helpers';
/**
 * Check if current domain is eligible for HRC
 *
 * @returns {Boolean} - true if domain is eligible for HRC
 */
export function isQsSiteEligibleForHrc() {
	const eligibleDomains = [
		'modernize.local',
		'modernize.com',
		'affordablestairliftsolutions.com',
		'airconditioningpros.org',
		'americanhomewarranty.org',
		'basementwaterproofingcosts.com',
		'bathandshower.org',
		'bathandshowerpros.com',
		'bathroompricing.com',
		'compareflooringprices.com',
		'emedicalalerts.com',
		'findyourwindows.com',
		'flooringpricer.com',
		'floridawindowprices.com',
		'foundationandbasements.com',
		'furnacereplacementcosts.org',
		'gutterguardcovers.com',
		'gutterguardinstallationprices.com',
		'go.bathandshowerpros.com',
		'go.homewindowprices.org',
		'go.walkinbathtubs.org',
		'homeelectricgenerators.org',
		'homesecurityprices.org',
		'homesolarrebate.com',
		'homewarrantyplans.org',
		'homewaterfilterprices.com',
		'homewatersystemspros.com',
		'homewindowprices.org',
		'hvaccostguide.com',
		'hvacpros.org',
		'kitchencabinetrefacing.org',
		'kitchensandcabinets.com',
		'leafgutterpros.com',
		'lifemedicalalerts.com',
		'localbathremodelcost.com',
		'localdeckpros.com',
		'localgaragedoorpros.org',
		'localroofingprices.net',
		'modernizesolar.com',
		'modernize-solar.com',
		'mygutterguards.com',
		'mysolarcost.com',
		'paverprices.com',
		'pennythepro.com',
		'plumbingservicecosts.com',
		'quotes.improvementcenter.com',
		'roofing-survey.com',
		'roofingcostguide.com',
		'roofingcosts.org',
		'roofingreplacementcost.com',
		'securitypricer.com',
		'sidingreplacementcost.com',
		'solarpanelpricing.com',
		'stairliftchairs.org',
		'thesidingremodelconnection.com',
		'tophottubs.org',
		'topinsulationpros.com',
		'treetrimmingservicepros.com',
		'walkinbathtubs.org',
		'walkintubforseniors.com',
		'walkintubprices.org',
		'wholehomewatersystems.org',
		'windowreplacementcost.org',
		'windowscostguide.com',
		'windowspromos.com',
		'windowsremodelconnection.com',
		'windowreplacementdeals.org',
		'windowssurvey.com',
		'homefoundationrepairpros.com',
		'localfencesquotes.com'
	];

	return eligibleDomains.indexOf(getDefaultSiteByDomain()) > -1;
}
